import { render, staticRenderFns } from "./PainelProjetosPessoais.vue?vue&type=template&id=73b6c054"
import script from "./PainelProjetosPessoais.vue?vue&type=script&lang=js"
export * from "./PainelProjetosPessoais.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosPessoais.vue?vue&type=style&index=0&id=73b6c054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports